import { render } from "./AuthorInfo.vue?vue&type=template&id=1332ac4e&scoped=true&ts=true"
import script from "./AuthorInfo.vue?vue&type=script&lang=ts"
export * from "./AuthorInfo.vue?vue&type=script&lang=ts"

import "./AuthorInfo.vue?vue&type=style&index=0&id=1332ac4e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1332ac4e"]])

export default __exports__